import { TranslatePipe } from '@ngx-translate/core';
import { SettingsConst } from '@/app/shared/consts/settings.const';

import { OnInit, Component, Renderer2 } from '@angular/core';

import { Alert } from '@/app/core/services/alert/alert';
import { AlertService } from '@/app/core/services/alert/alert.service';

import { ButtonComponent } from '@/app/shared/components/ui/button';
import { SvgIconComponent } from '@/app/shared/components/ui/svg-icon/svg-icon.component';

const ALERT_ANIMATION_CLASS = 'slide_animation_backwards';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  imports: [ButtonComponent, SvgIconComponent, TranslatePipe],
})
export class AlertComponent implements OnInit {
  protected alerts: Alert[] = [];

  constructor(
    private readonly alertService: AlertService,
    private readonly renderer: Renderer2,
  ) {}

  ngOnInit() {
    this.alertService.getAlert().subscribe((alert: Alert) => {
      if (!alert) {
        this.alerts = [];
        return;
      }

      this.alerts.push(alert);

      setTimeout(() => this.remove(alert, null), SettingsConst.alertDuration);
    });
  }

  protected remove(alert: Alert, event?: any, isChild?: boolean) {
    if (!event) {
      this.alerts = this.alerts.filter((existAlert) => existAlert !== alert);

      return;
    }

    const element = isChild ? event.currentTarget.parentElement : event.target;

    this.removeAlert(alert, element);
  }

  private removeAlert(alert: Alert, element: HTMLElement) {
    this.renderer.addClass(element, ALERT_ANIMATION_CLASS);

    setTimeout(() => {
      this.alerts = this.alerts.filter((existAlert) => existAlert !== alert);

      this.renderer.removeClass(element, ALERT_ANIMATION_CLASS);
    }, 300);
  }
}
